import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

interface ThemeToggleProps {
  className?: string;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ className = '' }) => {
  const { theme, toggleTheme } = useTheme();
  
  return (
    <button
      onClick={toggleTheme}
      className={`relative p-2 rounded-full bg-surface/50 backdrop-blur-md border border-slate-200 dark:border-white/10 shadow-lg text-slate-600 dark:text-slate-300 hover:text-primary dark:hover:text-white transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 ${className}`}
      aria-label={theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-pressed={theme === 'dark'}
    >
      <div className="relative w-5 h-5 overflow-hidden">
         {/* Sun Icon */}
         <svg 
           className={`absolute inset-0 w-full h-full transform transition-transform duration-500 ${theme === 'dark' ? 'translate-y-8 rotate-90 opacity-0' : 'translate-y-0 rotate-0 opacity-100'}`} 
           fill="none" viewBox="0 0 24 24" stroke="currentColor"
         >
           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
         </svg>
         {/* Moon Icon */}
         <svg 
           className={`absolute inset-0 w-full h-full transform transition-transform duration-500 ${theme === 'light' ? '-translate-y-8 -rotate-90 opacity-0' : 'translate-y-0 rotate-0 opacity-100'}`} 
           fill="none" viewBox="0 0 24 24" stroke="currentColor"
         >
           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
         </svg>
      </div>
    </button>
  );
};

export default ThemeToggle;